export const DANG_NHAP = "DANG_NHAP"
export const SET_THONG_TIN_NGUOI_DUNG = "SET_THONG_TIN_NGUOI_DUNG"